import useTranslation from 'next-translate/useTranslation'
import { Box, Flex } from '@/components/atoms/Grid'
import styled, { useTheme } from 'styled-components'
import Link from '@/components/atoms/link'
import { Capitalized, Capitalized2 } from '@/components/atoms/typography'
import { convertApiAttributeIdToAttributeId } from '@/types/attributeId'
import { AttributeId } from '@/network/graphql.g'
import { FC } from 'react'

type ProductSliderHeaderProps = {
  title: string
  getUrl: (gender: AttributeId) => string
  isWoman: boolean
}

const LandingPageProductSliderHeader: FC<ProductSliderHeaderProps> = ({
  title,
  getUrl,
  isWoman
}) => {
  const { t } = useTranslation('common')
  const theme = useTheme()
  return (
    <Box>
      <StyledCapitalized2 textAlign="center" mt={70} mb={10}>
        {title}
      </StyledCapitalized2>
      <Flex justifyContent="center" mb={30}>
        <StyledCapitalized>
          <Link
            href={getUrl(convertApiAttributeIdToAttributeId(AttributeId.Woman))}
            color={isWoman ? theme.colors.accent : theme.colors.onBackground}
          >
            {t('LandingPage.women')}
          </Link>
        </StyledCapitalized>
        <StyledCapitalized>/</StyledCapitalized>
        <StyledCapitalized>
          <Link
            href={getUrl(convertApiAttributeIdToAttributeId(AttributeId.Man))}
            color={!isWoman ? theme.colors.accent : theme.colors.onBackground}
          >
            {t('LandingPage.men')}
          </Link>
        </StyledCapitalized>
      </Flex>
    </Box>
  )
}

export default LandingPageProductSliderHeader

const StyledCapitalized = styled(Capitalized)`
  text-transform: uppercase;
  a {
    padding: 0 4px;
  }
`

const StyledCapitalized2 = styled(Capitalized2)`
  text-transform: uppercase;
`
